<div class="bg-light p-4" #scrollTabAnchor>
    <div class="row">
        <div class="col-12 col-md-4 order-0 order-md-reset">
            <button (click)="setNavTab('description')"
                    role="button"
                    class="btn btn-tab ff-spectral fs-6 fw-bold w-100 px-4 py-3 px-md-1 py-md-4"
                    [ngClass]="{'active': navTab === 'description'}">
                <svg-icon *ngIf="navTab !== 'description' && (deviceType$| async) === 'mobile'"
                          class="me-3"
                          src="assets/images/icon-chevron-right.svg"></svg-icon>
                <svg-icon *ngIf="navTab === 'description' && (deviceType$| async) === 'mobile'"
                          class="me-3"
                          src="assets/images/icon-chevron-down.svg"></svg-icon>
                Description
            </button>
        </div>
        <div class="col-12 col-md-4 order-2 order-md-reset">
            <button (click)="setNavTab('delivery')"
                    role="button"
                    class="btn btn-tab ff-spectral fs-6 fw-bold w-100 px-4 py-3 px-md-1 py-md-4"
                    [ngClass]="{'active': navTab === 'delivery'}">
                <svg-icon *ngIf="navTab !== 'delivery' && (deviceType$| async) === 'mobile'"
                          class="me-3"
                          src="assets/images/icon-chevron-right.svg"></svg-icon>
                <svg-icon *ngIf="navTab === 'delivery' && (deviceType$| async) === 'mobile'"
                          class="me-3"
                          src="assets/images/icon-chevron-down.svg"></svg-icon>
                Delivery &amp; Returns
            </button>
        </div>
        <div class="col-12 col-md-4 order-4 order-md-reset" *ngIf="product.layImages.length > 1">
            <button (click)="setNavTab('lay')"
                    role="button"
                    class="btn btn-tab ff-spectral fs-6 fw-bold w-100 px-4 py-3 px-md-1 py-md-4"
                    [ngClass]="{'active': navTab === 'lay'}">
                <svg-icon *ngIf="navTab !== 'lay' && (deviceType$| async) === 'mobile'"
                          class="me-3"
                          src="assets/images/icon-chevron-right.svg"></svg-icon>
                <svg-icon *ngIf="navTab === 'lay' && (deviceType$| async) === 'mobile'"
                          class="me-3"
                          src="assets/images/icon-chevron-down.svg"></svg-icon>
                Lay Patterns
            </button>
        </div>
        <div *ngIf="(deviceType$| async) === 'mobile'" class="col-12 order-6">
            <button (click)="setNavTab('guides')"
                    role="button"
                    class="btn btn-tab ff-spectral fs-6 fw-bold w-100 px-4 py-3 px-md-1 py-md-4"
                    [ngClass]="{'active': navTab === 'guides'}">
                <svg-icon *ngIf="navTab !== 'guides' && (deviceType$| async) === 'mobile'"
                          class="me-3"
                          src="assets/images/icon-chevron-right.svg"></svg-icon>
                <svg-icon *ngIf="navTab === 'guides' && (deviceType$| async) === 'mobile'"
                          class="me-3"
                          src="assets/images/icon-chevron-down.svg"></svg-icon>
                Guides & Colour Variants
            </button>
        </div>

        <div *ngIf="navTab === 'description'" class="tab--custom col-12 order-1 order-md-reset">
            <div class="bg-white p-4 px-5" [innerHTML]="product.description"></div>
        </div>

        <div *ngIf="navTab === 'delivery'" class="tab--custom col-12 order-3 order-md-reset">
            <div class="bg-white p-4 px-5">
                <span [innerHTML]="(settings$ | async)?.deliveryText"></span>
            </div>
        </div>

        <div *ngIf="navTab === 'lay' && product.layImages.length > 1" class="tab--custom col-12 order-5 order-md-reset">
            <div class="bg-white p-4 px-5">
                <ng-container *ngIf="product.layImages.length === 1">
                    <img
                        *ngFor="let i of product.layImages; let last = last;"
                        class="variation__img"
                        [src]="product.layImages[0].url"
                        [ngClass]="{'me-1': !last}">
                </ng-container>
                <app-product-details-pattern-slider
                    *ngIf="product.layImages.length > 1"
                    [images]="product.layImages"
                    [slidesPerView]="2"
                    [showNav]="false"></app-product-details-pattern-slider>
            </div>
        </div>

        <div *ngIf="navTab === 'guides' && (deviceType$| async) === 'mobile'" class="tab--custom col-12 order-7">
            <div class="bg-white p-4 px-5">
                <div class="d-flex justify-content-between">
                    <div (click)="viewColourVariations()" class="d-flex flex-column align-items-center">
                        <svg-icon src="/assets/images/icon-variations.svg"
                                  [svgClass]="'icon--variations'"></svg-icon>
                        <div class="ff-spectral text-center fs-variations lh-sm mt-3 mt-md-2">Colour<br/>Variations
                        </div>
                    </div>
                    <div class="d-flex flex-column align-items-center">
                        <a *ngIf="product.guides.installation" [href]="product.guides.installation" target="_blank">
                            <svg-icon src="/assets/images/icon-installation.svg"
                                      [svgClass]="'icon--variations'"></svg-icon>
                            <div class="ff-spectral text-center fs-variations lh-sm mt-3 mt-md-2">Installation<br/>Guide
                            </div>
                        </a>
                    </div>
                    <div class="d-flex flex-column align-items-center">
                        <a *ngIf="product.guides.product" [href]="product.guides.product" target="_blank">
                            <svg-icon src="/assets/images/icon-guide.svg"
                                      [svgClass]="'icon--variations'"></svg-icon>
                            <div class="ff-spectral text-center fs-variations lh-sm mt-3 mt-md-2">Product<br/>Guide
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
